import { ATTENDANCE_MANAGEMENT_PT_BR } from "../attendance-management/translations/attendance-management-pt-br";

export const BARS_AND_SECTORS_PT_BR = {
	title: "Bares",
	description:
		"Gerencie e personalize as configurações de estoque, impressoras e cardápios dos bares.",
	barsAndSectors: "Bares e Setores",
	bars: "Bares",
	sectors: "Setores",
	generalSettings: "Configurações Gerais",
	attendanceManagement: ATTENDANCE_MANAGEMENT_PT_BR,
	printByTableSettings: "Configuração de ambientes e mesas",
	editSector: "Editar setor",
	createSector: "Criar setor",
	createNewSector: "Criar novo setor",
	newSector: "Novo setor",
	searchPlaceholderSector: "Buscar por nome de setor ou bar",
	searchPlaceholderAccess: "Buscar por nome de acesso",
	sectorName: "Nome do setor",
	sectorBars: "Bares do setor",
	accessControl: "Grupo de acesso",
	createAccess: "Criar acesso",
	newAccess: "Novo acesso",
	editAccess: "Editar acesso",
	createNewAccess: "Criar novo acesso",
	accessName: "Nome do acesso",
	initialDate: "Início",
	endDate: "Fim",
	range: "Faixa de ZigCards",
	zigCardsId: "ID ZigCard",
	downloadModel: "Baixe a planilha modelo",
	selectFile: "Selecione um arquivo",
	selectFileDescription: "Tipo de arquivo [.xlsx, .xls] até [500 mb].",
	removeFile: "Remover arquivo",
	createAccessSuccess: "Acesso criado com sucesso",
	editAccessSuccess: "Acesso editado com sucesso",
	name: "Nome",
	initialDateHour: "Data e hora inicial",
	endDateHour: "Data e hora final",
	deleteSector: "Excluir setor",
	deleteSectorSubtitle: "Tem certeza que deseja excluir o setor?",
	deleteSectorSuccess: "Setor excluído com sucesso",
	editSectorSuccess: "Setor editado com sucesso",
	createSectorSuccess: "Setor criado com sucesso",
	deleteAccessPolicy: "Excluir acesso",
	deleteAccessPolicySubtitle: "Tem certeza que deseja excluir o acesso?",
	deleteAccessPolicySuccess: "Acesso excluído com sucesso",
	editAccessPolicySuccess: "Acesso editado com sucesso",
	createAccessPolicySuccess: "Acesso criado com sucesso",
	importAccessPolicyTagsSuccess: "Ids importadas com sucesso",
	accesses: "Acessos",
	sectorAccesses: "Acessos do setor",
	modelFileName: "planilha-modelo",
	noSectors: "Sem setores cadastrados",
	tagIdsError: "Adicione pelo menos um ID de ZigCard",
	onlySpacesError: "Campo não pode conter apenas espaços",
	seeZigCards: "Ver ZigCards",
};

export type BarsAndSectorsTranslations = typeof BARS_AND_SECTORS_PT_BR;
